<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="系统编号">
              <a-input v-model="queryParam.number" placeholder="系统编号" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="名称">
              <a-input v-model="queryParam.name" placeholder="名称" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1500 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 120px">
        {{ (text / 1).toFixed(2) | numberFormat }}
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelet(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-if="true">
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleRemark(record)">备注</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleClient(record)">客户</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleAttachment(record)">决策文件</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { STable } from '@/components'
import { project_list, project_create, project_delete } from '@/api/trade_project'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'
// import storage from '@/store'
// import { User_Id } from '@/store/mutation-types'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '编号',
          ellipsis: true,
          width: 150,
          fixed: 'left',
          dataIndex: 'number'
        },
        {
          title: '主体企业',
          ellipsis: true,
          width: 200,
          dataIndex: 'host_corporation'
        },
        {
          title: '名称',
          ellipsis: true,
          width: 150,
          dataIndex: 'name'
        },
        {
          title: '交易品种',
          ellipsis: true,
          width: 120,
          dataIndex: 'category'
        },
        {
          title: '参与人',
          ellipsis: true,
          width: 200,
          dataIndex: 'participants',
          customRender: (text) => text === '' || text === undefined ? '' : text.map(item => item['nickname'] ? item['nickname'] : item['name']).join(',')
        },
        {
          title: '负责人',
          ellipsis: true,
          width: 120,
          dataIndex: 'leader'
        },
        {
          title: '金蝶业务号编码',
          ellipsis: true,
          width: 120,
          dataIndex: 'jd_code'
        },
        {
          title: '待落实前提条件',
          ellipsis: true,
          width: 200,
          dataIndex: 'precondition'
        },
        {
          title: '创建人',
          ellipsis: true,
          width: 120,
          dataIndex: 'create_by'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return project_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { code: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() + hours + minutes }
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false

      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id })
    },
    handleClient (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id + '/client', query: { record: record.host_corporation } })
    },
    handleRemark (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id + '/remark', query: { record: record.host_corporation } })
    },
    handleDetail (record) {
      this.$router.push({ path: '/trade/project/' + record.id + '/detail', query: { record: record.id, host_corporation_id: record.host_corporation_id } })
    },
    handleAttachment (record) {
      this.$router.push({ path: '/trade/project/' + record.id + '/attachment', query: { name: record.name } })
    },
    handleDelet (record) {
      project_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
          // 新增
          values.decision_files = undefined
          values.decision_url = undefined
          values.start_date = data.start_date
          values.end_date = data.end_date
          values.date = undefined
          values.decision_files = data.file_list
          values.participant_ids = values.participant_ids.map(item => {
            return item['key']
          })
          project_create(values).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.visible = false
              form.resetFields()
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  }
}
</script>
